import { Button } from "@/components/ui/Button";
import { Dialog } from "@/components/ui/Dialog";
import { Input } from "@/components/ui/Input";
import { useEffect, useState } from "react";

interface CreateEditAccountMappingDialogProps {
  open: boolean;
  nameToEdit: string | null;
  onOpenChange: (open: boolean) => void;
  onSubmitAccountMapping: (editMode: boolean, name: string) => void;
}

export const CreateEditAccountMappingDialog = ({
  open,
  nameToEdit,
  onOpenChange,
  onSubmitAccountMapping,
}: CreateEditAccountMappingDialogProps) => {
  const [name, setName] = useState("");

  useEffect(() => {
    if (nameToEdit) {
      setName(nameToEdit);
    } else {
      setName("");
    }
  }
  , [nameToEdit]);

  const cleanState = () => {
    setName("");
    onOpenChange(false);
  }

  const handleCreate = () => {
    onSubmitAccountMapping(!!nameToEdit, name.trim());
    cleanState();
  };

  const handleClose = () => {
    onOpenChange(false);
    cleanState();
  }

  const isValid = () => {
    return !name.trim();
  }

  return (
    <Dialog
      open={open}
      onClose={() => handleClose()}
      title={nameToEdit ? "Redigera kontomappning" : "Skapa ny kontomappning"}
      footer={
        <div className="flex justify-end gap-4 pb-2 pr-2">
          <Button variant="outlined" onClick={() => handleClose()}>
            Avbryt
          </Button>
          <Button onClick={handleCreate} disabled={isValid()}>
            {nameToEdit ? "Spara" : "Skapa"}
          </Button>
        </div>
      }
    >
      <div>
        <div className="py-2">
          <Input
            label="Namn"
            value={name}
            onChange={(e) => setName(e.target.value)}
          />
        </div>
      </div>
    </Dialog >
  );
};